import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getFloatingItem} from '../../../apis/floating/getFloatingItem'

const useQueryFloatingItem = id => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.floating.getFloatingItem(id),
        queryFn: async () => {
            const {data, pageInfo} = await getFloatingItem(id)
            return {data, pageInfo}
        },
        cacheTime: 0, // 캐시 저장 안 함
        staleTime: 0, // 항상 새 데이터를 가져오도록 설정
        refetchOnWindowFocus: false,
    })

    return {data: data?.data, pageInfo: data?.pageInfo, refetch}
}

export default useQueryFloatingItem
